import { useAuth } from '@/auth/useAuth';
import { SplashButton } from '@/components/SplashButton';

/**
 * Dashboard splash menu — reproduces AST2's index.php `#master-menu`:
 * a "Welcome {name}" title above a stack of AST-blue splash tiles.
 */
export default function DashboardPage() {
  const { user } = useAuth();

  return (
    <div className="ast-master-menu text-center mx-auto">
      <div className="splash-title sans-serif">Welcome {user?.name ?? ''}</div>

      <div className="ast-splash-list">
        <SplashButton icon="bi-envelope-open" label="View / Create Closing Protection Letters" to="/cpls" />
        <SplashButton icon="bi-folder2-open" label="View / Create Jackets" to="/jackets" />
        <SplashButton icon="bi-calculator" label="Use The Rate Calculator" to="/rate" />
        <SplashButton icon="bi-person" label="Manage Your Account" to="/account" />
        {user?.role === 2 && <SplashButton icon="bi-people" label="Admin" to="/admin" />}
      </div>
    </div>
  );
}
